<template>
  <div>
    <h1 v-if="templateType === 'info'">
      このたびはご利用いただき、<br class="sp_only">誠にありがとうございます。
    </h1>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["page", "code_error", "ispc"])
  },
  props: ["templateType"],
  name: "header-bar"
};
</script>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue